import React, {Component} from 'react'

class AlgoText extends Component {
    constructor(props) {
        /* textMap{"intuition":JSX...}, algoType */
        super(props)
        console.log("algoText props", props)
    }

    render() {
        const detailMap = {
            intuition: {
                heading: 'Intuition',
                color: '#90ee90'
            },
            analysis: {
                number: 2,
                heading: 'Analysis',
                color: '#b366ff'
            },
            songAndCode: {
                number: 3,
                heading: 'Song & Code',
                color: 'orange'
            }
        }

        const divToDisplay = this.props.textMap[this.props.algoType]

        if (this.props.algoType.length === 0) {
            return(<p></p>)
        }

        return (
            <div className="contentBlock">
                <h2>{detailMap[this.props.algoType]['heading']}</h2>
                <div 
                className="delim" 
                style={{
                    backgroundColor: detailMap[this.props.algoType]['color'],
                    width: '100%'
                }}></div>
                {divToDisplay}
            </div>
        )
    }
}
export default AlgoText


// WEBPACK FOOTER //
// ./src/AlgoText/AlgoText.js